import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.example.com',
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
    'Cache-Control': 'public, max-age=3600',
    'Pragma': 'no-cache',
    'X-Requested-With': 'XMLHttpRequest',
    'Accept-Language': 'ko-KR,ko;q=0.9,en-US;q=0.8,en;q=0.7'
  },
});

export const main = {
  getMain: () => api.get('/main'),
}

export const artist = {
  getArtist: () => api.get('/artist'),
  getArtistDetail: (id) => api.get(`/artist/${id}`),
}

export const press = {
  getPress: () => api.get('/press'),
  getPressDetail: (id) => api.get(`/press/${id}`),
}
